<template>
    <div @click="scrollTop" class="back-to-top" :class="[activeClass]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BackToTop',

    props: {
        threshold: {type: Number, default: 100},
    },

    data() {
        return {
            position: window.pageYOffset,
        };
    },

    computed: {
        activeClass() {
            return this.isActive ? 'back-to-top-active' : 'back-to-top-inactive';
        },

        isActive() {
            return this.position > this.threshold;
        }
    },

    methods: {
        scrollTop() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },

        onScroll() {
            this.position = window.pageYOffset;
        },
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll, {passive: true});
    },

    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    }
}
</script>
